// <s-typo-preview> — mirrors the text typed into a child text input into each
// [data-typo-preview] descendant, so font previews show the buyer's own text.
// Falls back to each preview's initial text when the input is empty.
// One component per file.
class STypoPreview extends HTMLElement {
  #ac = null;

  connectedCallback() {
    const input = this.querySelector('input[type="text"]');
    const previews = [...this.querySelectorAll("[data-typo-preview]")];
    if (!input || !previews.length) return;

    this.#ac = new AbortController();
    const signal = this.#ac.signal;

    const fallbacks = new Map(previews.map((el) => [el, el.textContent]));
    const update = () => {
      const value = input.value.trim();
      previews.forEach((el) => {
        el.textContent = value || fallbacks.get(el);
      });
    };
    input.addEventListener("input", update, { signal });
    update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get("s-typo-preview")) {
  customElements.define("s-typo-preview", STypoPreview);
}
